// Mobile Nav Menu Functionality
const links = document.getElementById("navigation-items");
const toggler = document.getElementById("navigation-toggle");
const hero = document.querySelector("[data-hero]");

function toggleLinks() {
  links.classList.toggle("hidden");
}

function getBrowserWidth() {
  const width = window.innerWidth;
  if (width > 1024) {
    if (!links.classList.contains("hidden")) {
      toggleLinks();
    }
  }
}

window.onload = getBrowserWidth;
window.onresize = getBrowserWidth;
if (toggler) toggler.addEventListener("click", toggleLinks);
